
import { haversineDistanceMeters } from "../locationUtils";
/********************************************/
//Helper Functions
/********************************************/

export const getUSandDSAgms = (closestSegment, polyLineArr) => {
    let upstreamAgm;
    let downstreamAgm;
    let downstreamSc;
    let upstreamSc;
    for (let i = closestSegment.segmentIndex + 1; i < polyLineArr.length; i++) {
        if (polyLineArr[i].agm) {
            downstreamAgm = polyLineArr[i];
            break;
        }
    }
    for (let i = closestSegment.segmentIndex + 1; i < polyLineArr.length; i++) {
        if (polyLineArr[i].subchain) {
            downstreamSc = polyLineArr[i];
            break;
        }
    }
    for (let i = closestSegment.segmentIndex; i >= 0; i--) {
        if (polyLineArr[i].agm) {
            upstreamAgm = polyLineArr[i];
            break;
        }
    }
    for (let i = closestSegment.segmentIndex; i >= 0; i--) {
        if (polyLineArr[i].subchain) {
            upstreamSc = polyLineArr[i];
            break;
        }
    }
    return { upstreamAgm, downstreamAgm, upstreamSc, downstreamSc }
}

export const getUSandDSDists = (usAgm, dsAgm, point) => {
    let usLat = usAgm.Real_Lat ? usAgm.Real_Lat : usAgm.Est_Lat;
    let usLng = usAgm.Real_Lng ? usAgm.Real_Lng : usAgm.Est_Lng;
    let dsLat = dsAgm.Real_Lat ? dsAgm.Real_Lat : dsAgm.Est_Lat;
    let dsLng = dsAgm.Real_Lng ? dsAgm.Real_Lng : dsAgm.Est_Lng;

    let distToUS = haversineDistanceMeters(usLat, usLng, point.lat, point.lng);
    let distToDS = haversineDistanceMeters(dsLat, dsLng, point.lat, point.lng);

    return { distToUS, distToDS }
}